import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { add_update_delete_dash_menu } from "../../../data/ApiEndpoints";

function validateForm(formValues) {
  let errors = [];

  formValues.forEach((items, index) => {
    let itemErrors = {};

    if (!items?.menuName) {
      itemErrors.menuName = `required!`;
    } else if (items.menuName?.length > 100) {
      itemErrors.menuName = `menu name can not be more than 100 characters!`;
    }

    if (!items?.sequenceNumber) {
      itemErrors.sequenceNumber = `required!`;
    }

    if (Object.keys(itemErrors).length > 0) {
      errors[index] = itemErrors;
    }
  });

  return errors;
}

const DashMenuForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const iniFormvaluesRaw = {
    menuName: "",
    sequenceNumber: "",
    isActive: false,
  };
  const iniFormvalues = {
    menuName: isEdit && rowData?.menu_name ? rowData.menu_name : "",
    sequenceNumber: isEdit && rowData?.sequence_no ? rowData.sequence_no : "",
    isActive: isEdit && rowData?.status ? true : false,
  };
  const [formValues, setFormValues] = useState([iniFormvalues]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e, index) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => {
      const updatedFormValues = [...prevs];
      updatedFormValues[index] = {
        ...updatedFormValues[index],
        [name]: type === "checkbox" ? checked : value,
      };
      return updatedFormValues;
    });
  };

  const handleAddMore = () => {
    setFormValues((prevs) => [...prevs, iniFormvaluesRaw]);
  };

  const handleRemove = (index) => {
    setFormValues((prevs) => prevs.filter((_, i) => i !== index));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = add_update_delete_dash_menu;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const formDatas = formValues.map((item) => {
        return {
          menu_name: item.menuName || "",
          sequence_no: item.sequenceNumber || "",
          status: item.isActive ? 1 : 0,
        };
      });

      const userData = {
        menues: formDatas,
      };

      let userDataEdit = {};

      if (isEdit) {
        const { menuName, sequenceNumber, isActive } = formValues[0];

        userDataEdit.menu_id = rowData?.menu_id || "";
        userDataEdit.menu_name = menuName || "";
        userDataEdit.sequence_no = sequenceNumber || "";
        userDataEdit.status = isActive ? 1 : 0;
      }

      const handleConfirm = async () => {
        handleAdd(isEdit ? userDataEdit : userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${isEdit ? "Update" : "Add"} Menu`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title="Manage Dashboard Menus"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        {formValues.map((items, index) => (
          <div key={index} className="formInputsGrid twoGridSystem">
            <div className="formInputBox span2">
              <label htmlFor="menuName" className={`formInputLabel `}>
                menu name (max 100 - {items?.menuName?.length}){" "}
                <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Feature Name"
                className={`formInput ${
                  formErrors?.[index]?.menuName ? "formError" : ""
                }`}
                name="menuName"
                value={items?.menuName || ""}
                onChange={(e) => onChangeInput(e, index)}
              />

              {formErrors?.[index]?.menuName && (
                <span className="error-label">
                  {formErrors[index].menuName}
                </span>
              )}
            </div>

            <div className="formInputBox">
              <label htmlFor="sequenceNumber" className={`formInputLabel `}>
                sequence <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Sequence Number"
                className={`formInput ${
                  formErrors?.[index]?.sequenceNumber ? "formError" : ""
                }`}
                name="sequenceNumber"
                value={items?.sequenceNumber || ""}
                onChange={(e) => onChangeInput(e, index)}
              />

              {formErrors?.[index]?.sequenceNumber && (
                <span className="error-label">
                  {formErrors[index].sequenceNumber}
                </span>
              )}
            </div>

            <div
              className="formInputBox formInputSwitchAddMore span2"
              style={{ flexDirection: "row" }}
            >
              <div
                className={`commonWrapper commonSwitchWrapper no-border`}
                style={{ width: "30%" }}
              >
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={`${items.isActive ? "Active" : "Inactive"}`}
                  checked={items?.isActive}
                  onChange={(e) => onChangeInput(e, index, "check")}
                />
              </div>

              {!isEdit && (
                <div
                  className="extraBtnWrapper"
                  style={{
                    height: "60px",
                    flexDirection: "row",
                    columnGap: "15px",
                    alignItems: "center",
                  }}
                >
                  {formValues.length !== 1 && (
                    <button
                      type="button"
                      className="btn btn-danger extraBtn"
                      onClick={() => handleRemove(index)}
                    >
                      Remove
                    </button>
                  )}
                  {index === formValues.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-dark extraBtn"
                      onClick={handleAddMore}
                    >
                      + Add more
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </form>
    </div>
  );
};

export default DashMenuForm;
